import { FormattedMessage, useIntl } from 'react-intl';
import { FormElement } from '../FormElement';
import { FormSection } from '../FormSection';
import { UserDTO } from '@/api/trafikportalen';

interface Props {
  administrator: UserDTO;
}

export const SystemAdministratorProfileForm = ({ administrator }: Props) => {
  const { formatMessage } = useIntl();

  return (
    <FormSection title={<FormattedMessage defaultMessage="Profil" />}>
      <FormElement
        label={<FormattedMessage defaultMessage="Förnamn" />}
        input={
          <p>
            {administrator.firstname || (
              <i className="text-text-700">
                {formatMessage({ defaultMessage: 'Inget värde' })}
              </i>
            )}
          </p>
        }
      />
      <FormElement
        label={<FormattedMessage defaultMessage="Efternamn" />}
        input={
          <p>
            {administrator.lastname || (
              <i className="text-text-700">
                {formatMessage({ defaultMessage: 'Inget värde' })}
              </i>
            )}
          </p>
        }
      />
      <FormElement
        label={<FormattedMessage defaultMessage="E-post" />}
        input={<p>{administrator.email}</p>}
      />
      <i className="text-text-800">
        <FormattedMessage defaultMessage="Profilinformationen ändras av användaren själv" />
      </i>
    </FormSection>
  );
};
